export default {
  methods: {
    //DISPATCHES
    //Since the Event Handler listens for any error events with this `error-xyz` event name,
    //whenever you want to alert an error in your application you can invoke the Event-Handler with this method
    setError(err, prevent, actionEv) {
      const status = err?.response?.status;

      if (!status || status >= 500) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      const response = err?.response;
      document.dispatchEvent(
        new CustomEvent("error-" + response.status, {
          detail: {
            preventDefault: Boolean(prevent),
            callbackEvent: actionEv,
            data: response,
          },
        }),
      );
    },
  },
};
